import { useEffect, useState } from 'react'
import { Row, Container } from 'react-bootstrap'
import "react-responsive-carousel/lib/styles/carousel.min.css"

//image
import axios from 'axios'
import toast, { Toaster } from 'react-hot-toast';
import { getToken } from '../../utils/auth'
import { useNavigate } from 'react-router-dom'
import SavePostCard from './SavePost/SavePostCard'
import useAuth from '../../utils/useAuth'

const Saved = () => {
    useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        if (!getToken()) {
            navigate("/auth/sign-in")
        }
    }, []);
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [description, setDescription] = useState("");
    const [selectedFile, setSelectedFile] = useState([]);
    const [expandedRows, setExpandedRows] = useState({});

    const [post, setPost] = useState([]);
    const [lostPost, setLostPost] = useState([]);
    const handleAllPost = async () => {
        try {
            const token = getToken();
            const response = await axios.get(
                `${process.env.REACT_APP_URL}/api/post/saved/all`, {
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "multipart/form-data"
                }
            }
            )
            setPost(response.data.data.allPosts);
        } catch (error) {
            console.log("Failed Fetching Posts", error);
        }
    }
    const handleAllLostPost = async () => {
        try {
            const token = getToken();
            const response = await axios.get(
                `${process.env.REACT_APP_URL}/api/device/saved/all`, {
                headers: {
                    "Authorization": `Bearer ${token}`,
                    // "Content-Type": "multipart/form-data"
                }
            }
            )
            setLostPost(response.data.data.allSavedLostDevice);
        } catch (error) {
            console.log("Failed Fetching Posts", error);
        }
    }

    useEffect(() => {
        handleAllPost();
        handleAllLostPost();
    }, [])


    return (
        <>
<Toaster position="top-right" reverseOrder={false}/>
<div id="content-page" className="content-page">

                <Container>
                    <Row>
                       <SavePostCard post={post} handleAllPost={handleAllPost} lostPost={lostPost} handleAllLostPost={handleAllLostPost}/>

                        {/* <div className="col-sm-12 text-center">
                        <img src={loader} alt="loader" style={{height: "100px"}}/>
                    </div> */}
                    </Row>
                </Container>
            </div>
        </>
    )
}

export default Saved
